import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { onBlankLayout } from 'store/slices/themeSlice';
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { SUPPORT_HELP_PUBLIC_PATH } from 'configs/AppConfig';
import { checkRouteAccess } from 'utils/permissionUtils';
import { SEC_AUTH_M_TK } from 'constants/AuthConstant';

const AppRoute = ({ component: Component, routeKey, blankLayout, roles, premiumRequired, ...props }) => {
	const dispatch = useDispatch()
	
	const token = localStorage.getItem(SEC_AUTH_M_TK);

	useEffect(() => {
		const isBlank = blankLayout ? true : false
		dispatch(onBlankLayout(isBlank))
	}, [blankLayout,dispatch])

	const isPublicRoute = window.location.pathname.startsWith('/auth') ||
		window.location.pathname === '/' ||
		window.location.pathname === '/pricing' ||
		window.location.pathname === SUPPORT_HELP_PUBLIC_PATH ||
		window.location.pathname.startsWith('/health') ||
		window.location.pathname.startsWith('/payment/success') ||
		window.location.pathname.startsWith('/payment/cancel') ||
		window.location.pathname.startsWith('/payment/status') ||
		window.location.pathname.startsWith('/user-reset-password') ||
		window.location.pathname.startsWith('/forget-reset-password');

	if (isPublicRoute) {
		return <Component {...props} permissionInfo={null} />;
	}

	const routeAccess = checkRouteAccess(roles, premiumRequired, token);

	console.log('AppRoute - routeAccess:', routeAccess);
	console.log('AppRoute - premiumRequired:', premiumRequired);
	console.log('AppRoute - roles:', roles);

	// Stronger prevention: if already on the redirectTo path, and that path is in the allowedInactivePlanRoutes, just render the component
	if (!routeAccess.hasAccess) {
		if (
			routeAccess.redirectTo &&
			window.location.pathname === routeAccess.redirectTo &&
			(
				routeAccess.redirectTo === '/app/pages/payment' ||
				routeAccess.redirectTo === '/error-page-1' ||
				routeAccess.redirectTo === '/auth/login'
			)
		) {
			return <Component {...props} permissionInfo={routeAccess.permissionInfo} />;
		}
		switch (routeAccess.reason) {
			case 'NO_TOKEN':
				console.log('AppRoute - No token, redirecting to login');
				return <Navigate to="/auth/login" replace />;
			case 'PLAN_INACTIVE':
				console.log('AppRoute - Plan inactive, redirecting to payment');
				return <Navigate to="/app/pages/payment" replace />;
			case 'ROLE_NOT_ALLOWED':
			case 'PREMIUM_REQUIRED':
			case 'SUBSCRIPTION_REQUIRED':
			default:
				console.log('AppRoute - Access denied, redirecting to error page');
				return <Navigate to="/error-page-1" replace />;
		}
	}

	return (
		<Component {...props} permissionInfo={routeAccess.permissionInfo} />
	)
}

AppRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  routeKey: PropTypes.string,
  blankLayout: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.string),
  premiumRequired: PropTypes.bool,
};

export default AppRoute